var app = angular.module('leonardo');

var CurrencyFormat = function ($filter) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];

      scope.regex = /[+-]?\d+(,\d+)*(\.\d+)?/g;

      scope.symbol = !isNull(attrs.symbol) ? attrs.symbol : '$';
      scope.fractionSize = !isNull(attrs.fractionSize) ? parseInt(attrs.fractionSize) : 2;

      scope.setValue = function (value) {
        if (!isNull(value)) {
          var value_num = value.replace(scope.symbol, "");
          if (!isNull(value_num) && (value_num[0] === '.')) {
            value_num = '0' + value_num;
          }
          var match = value_num.match(scope.regex);
          if (!isNull(match)) {
            match.map(function (v) {
              element.val($filter('currency')(v.split(',').join(''), scope.symbol, scope.fractionSize));
              scope.ngModelCtrl.$setViewValue(v.split(',').join(''));
            });
          }
          else {
            scope.ngModelCtrl.$setViewValue(null);
          }
        }
      }

      scope.setInputFilter = function (textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
          textbox.addEventListener(event, function() {
            if (inputFilter(this.value)) {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
          });
        });
      };

      scope.setInputFilter(element[0], function(value) {
        return /^-?\$?\d*(?:\.\d*)?$/.test(value);
      });

      scope.$watch(attrs.ngModel, function (value) {
        scope.value = value;
        scope.setValue(scope.value);
      });

      scope.$watch(attrs.symbol, function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.symbol = !isNull(newValue) ? newValue : '$';
          scope.setValue(scope.value);
        }
      })
    }
  };
};

app.directive('currencyFormat', ['$filter', CurrencyFormat]);